import React from "react";
import { CheckCircle2, XCircle, Clock } from "lucide-react";

const ReactionHistory = ({ reactions = [] }) => {
  if (!reactions || reactions.length === 0) return null;

  const fmtDate = (dStr) => {
    if (!dStr) return "";
    try {
      return new Date(dStr).toLocaleDateString("en-IN", {
        day: "2-digit",
        month: "short",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      });
    } catch (e) {
      return dStr;
    }
  };

  return (
    <div className="mt-3 pt-3 border-t border-gray-100">
      <h4 className="text-xs font-semibold text-gray-500 uppercase tracking-wider mb-2">
        Evaluations & Approvals ({reactions.length})
      </h4>
      <div className="flex flex-wrap gap-2">
        {reactions.map((r, idx) => {
          const isApprove = r.type === "✅" || r.type === "approved" || r.type === "APPROVED" || r.decision === "Approved";
          const subroleLabel = r.subrole || (r.from_source === "HOD" ? "Head of Department (HOD)" : "Faculty Member");

          return (
            <div
              key={idx}
              className={`flex items-center gap-2 px-3 py-1.5 rounded-lg border text-xs ${
                isApprove
                  ? r.from_source === "HOD" ? "bg-purple-50 border-purple-200 text-purple-900" : "bg-emerald-50 border-emerald-200 text-emerald-800"
                  : "bg-rose-50 border-rose-200 text-rose-800"
              }`}
            >
              {isApprove ? (
                <CheckCircle2 className={`w-3.5 h-3.5 flex-shrink-0 ${r.from_source === "HOD" ? "text-purple-600" : "text-emerald-600"}`} />
              ) : (
                <XCircle className="w-3.5 h-3.5 text-rose-600 flex-shrink-0" />
              )}
              <div className="flex flex-col">
                <span className="font-bold">{subroleLabel}: {r.from || r.professorEmail || "Evaluator"}</span>
                <span className="text-[10px] text-gray-500 flex items-center gap-1">
                  <Clock className="w-3 h-3 inline" /> {fmtDate(r.timestamp)}
                </span>
              </div>
              {r.signature && (
                <img
                  src={r.signature}
                  alt="Signature"
                  className="h-5 object-contain ml-1 border-l pl-1 border-gray-200"
                  title="Electronic Signature Attached"
                />
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ReactionHistory;
